<script lang="ts" setup>
import { ModalContentProps } from "~/components/Filters/Utils/ModalContent.props"
import { useElementOverflow } from "~/composables/useElementOverflow"

withDefaults(defineProps<ModalContentProps>(), {
  btnShown: false
})

const emit =
  defineEmits<{
    (e: "onMounted", fn: () => void): void
    (e: "onClick"): void
  }>()

const contentRef = ref<HTMLElement | null>(null)
const { isOverflowing, refresh } = useElementOverflow(contentRef)

const transitionend = ref(true)
const toggleTransitionEnd = (value: boolean) => (transitionend.value = value)

onMounted(() => emit("onMounted", refresh))
watch(transitionend, () => window.requestAnimationFrame(refresh))
</script>

<template>
  <div
    ref="contentRef"
    class="modal-content overflow-y-auto px-4 pb-4"
    :class="{
      'height-transitioned': transitionend,
      'height-not-transitioned': !transitionend
    }"
  >
    <slot />
  </div>
  <Transition
    name="slide-fade"
    @before-enter="toggleTransitionEnd(false)"
    @after-leave="toggleTransitionEnd(true)"
  >
    <FiltersUtilsOverflowButton
      v-if="btnShown"
      v-bind="btn"
      :overflow="isOverflowing"
      @onClick="emit('onClick')"
    />
  </Transition>
</template>

<style lang="scss" scoped>

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(20px);
  opacity: 0;
}

.height-transitioned {
  height: calc(100vh - 3rem);
  height: calc(100dvh - 3rem);
}
.height-not-transitioned {
  height: calc(100vh - 7.5rem);
  height: calc(100dvh - 7.5rem);
}

</style>
